import * as React from 'react';
import { useInstantSearch } from 'react-instantsearch';

const CurrentPageStats = (props) => {
  const stateResults = useInstantSearch(props);

  if (!stateResults.results) {
    return null;
  }

  const {nbHits, hitsPerPage, page, hits} = stateResults.results;

  let maxItems = hitsPerPage * (page + 1);
  if (maxItems > nbHits) {
    maxItems = nbHits;
  }
  const minItems = maxItems - hits.length + 1;

  return (
    <div className='current-page-stats'>
      {I18n.t('faceted_search.pagination.prefix')}
      <b>{I18n.t('faceted_search.pagination.range_template', {first: minItems, last: maxItems})}</b>
      {I18n.t('faceted_search.pagination.of_total', {total: nbHits})}
    </div>
  );
};

export default CurrentPageStats;
